import {
  handleRequest,
  handleAvailable,
  handleUnavailable,
} from '../reducerHandlers';
import {
  CONSOLIDATION_REQUEST,
  CONSOLIDATION_AVAILABLE,
  CONSOLIDATION_UNAVAILABLE,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
  storeConfigs: [],
  isLoadingStoreConfigs: false,
};

export const reducer = createReducer(defaultState, {
  [CONSOLIDATION_REQUEST]: handleRequest,
  [CONSOLIDATION_AVAILABLE]: handleAvailable,
  [CONSOLIDATION_UNAVAILABLE]: handleUnavailable,
});

export function getConsolidationStages(payload) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'consolidationStages';
    const loadingName = 'isLoadingConsolidationStages';
    dispatch({
      type: CONSOLIDATION_REQUEST,
      payload: { loadingName: loadingName },
    });
    try {
      const response = await dataSource.getConsolidationStages(payload);
      dispatch({
        type: CONSOLIDATION_AVAILABLE,
        payload: {
          keyState: keyState,
          data: response,
          loadingName: loadingName,
        },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CONSOLIDATION_UNAVAILABLE,
        payload: {
          keyState: keyState,
          loadingName: loadingName,
          defaultState: [],
        },
      });
    }
  };
}
